import { useMemo } from 'react'
import { useGetMyPoint } from './query/point/useGetMyPoint'

interface UsePointManagerOptions {
  requiredPoints: number
}

interface UsePointManagerReturn {
  currentPoint: number
  isValidPoint: boolean
  hasEnoughPoints: boolean
  isLoading: boolean
  refetch: () => void
  checkPointsRealtime: () => Promise<boolean>
}

/**
 * 포인트 관리를 위한 공통 훅
 * 현재 사용자의 포인트를 조회하고 필요 포인트와 비교하여 유효성을 검증합니다.
 *
 * @param requiredPoints - 필요한 포인트 수
 * @returns 포인트 관련 상태와 유효성 검증 결과
 */
export const usePointManager = ({
  requiredPoints,
}: UsePointManagerOptions): UsePointManagerReturn => {
  const { data: pointData, isLoading, refetch } = useGetMyPoint()

  const currentPoint = useMemo(() => {
    return pointData?.totalPoint || 0
  }, [pointData])

  const isValidPoint = useMemo(() => {
    return currentPoint >= requiredPoints
  }, [currentPoint, requiredPoints])

  const hasEnoughPoints = useMemo(() => {
    return currentPoint >= requiredPoints
  }, [currentPoint, requiredPoints])

  // 실시간 포인트 체크 함수
  const checkPointsRealtime = async (): Promise<boolean> => {
    try {
      const result = await refetch()
      console.log(result.data)
      const latestPoint = result.data?.totalPoint || 0
      return latestPoint >= requiredPoints
    } catch (error) {
      console.error('포인트 실시간 체크 실패:', error)
      return false
    }
  }

  return {
    currentPoint,
    isValidPoint,
    hasEnoughPoints,
    isLoading,
    refetch,
    checkPointsRealtime,
  }
}
